interface WeekGridDateProps {
  date: string;
}

export function WeekGridDate({ date }: WeekGridDateProps) {
  // Convertir la string en Date
  const jsDate = new Date(date);
  const today = new Date();
  const isToday = jsDate.toDateString() === today.toDateString();

  // Noms des jours en français (abrégés)
  const dayNames = ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"];
  const dayName = dayNames[jsDate.getDay()];
  const dayNumber = jsDate.getDate();

  return (
    <div className="flex flex-col items-center py-1 text-xs font-medium text-gray-600">
      <div className={`text-center text-[10px] tracking-wide uppercase ${isToday ? "text-orange-500" : ""}`}>{dayName}</div>
      <div className={`flex h-8 w-8 items-center justify-center rounded-full text-lg font-semibold ${isToday ? "bg-orange-500 text-white" : "text-gray-900"}`}>
        {dayNumber}
      </div>
    </div>
  );
}
